import React, { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';

import { Box, useGlobalZoomLevel, Icon, theme } from '@sbv-clients/ui-shared';

type SharedAuthLayoutProps = PropsWithChildren & {
  isCheckIcon?: boolean;
};

export const SharedAuthLayout = ({
  children,
  isCheckIcon = false,
}: SharedAuthLayoutProps) => {
  const zoom = useGlobalZoomLevel(1);

  return (
    <Box
      sx={{
        width: `${100 / zoom}vw`,
        minHeight: `${100 / zoom}vh`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: theme.custom?.authPageGradient,
        py: 8,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          maxWidth: '680px',
          mx: 3,
          borderRadius: '20px',
          bgcolor: theme.background.white,
          boxShadow: theme.custom?.authCardShadow,
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '4px',
            borderRadius: '20px 20px 0 0',
            background: `linear-gradient(90deg, ${theme.colors.primary.main}, ${theme.colors.gold})`,
          },
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          px={{ xs: 5, md: 10 }}
          pt={8}
          pb={{ xs: 6, md: 9 }}
        >
          <Link to="/">
            <Icon
              name={'LogoSVG'}
              customSizes={{ width: '200px', height: '61px' }}
            />
          </Link>
          {isCheckIcon && (
            <Box display="flex" justifyContent="center" mt={6}>
              <Icon name={'Check'} />
            </Box>
          )}
          <Box width="100%" mt={6}>
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default SharedAuthLayout;
